import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../config/config';
import { AllFrontendSettingsCommand } from '../../../../commands/visitor/all.frontend.settings.command';
import { ButtonTriggerEvent, MatFieldComponent } from '../../../../common/components';
import {
  FacebookLoginButtonComponent
} from '../../../../common/components/facebook.login.button/facebook.login.button.component';
import { FacebookPost } from '../../../../common/components/facebook.post/facebook.post';
import { HubEvent } from '../../../../models/hub/hub.event';
import { HubPlaceAdditionalData } from '../../../../models/hub/hub.google.place.data';
import { HubPlace } from '../../../../models/hub/hub.place';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { PlaceService } from '../../../../services/place.service';
import { SeoService } from '../../../../services/seo.service';
import { ShareService } from '../../../../services/share.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef, MatMenuTrigger } from '@angular/material';
import {
  AllFrontendSettingsStore,
  VisitorTripNotifyAddOrRemoveItemStore,
  VisitorTripStore,
} from '../../../../stores/visitor.calendar.store';
import { TripDetailModalActions, TripDetailModalData } from './trip.detail.modal.provider';
import { ImageComponent } from '../../../../common/components/image/image.component';
import { ImageViewerComponent } from '../../../../common/components/image.viewer/image.viewer.component';
import { Location } from '@angular/common';
import { ShowInfoModalComponent } from '../../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../../hub/show.info.modal/show.info.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  templateUrl: './trip.detail.modal.component.html',
  styleUrls: ['./trip.detail.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TripDetailModalComponent extends BaseComponent implements OnInit {
  public data: TripDetailModalData;
  public hubName: string;
  public userFacebookID: string;
  public placeFeeds: FacebookPost[];
  public placeFeedPaging: {next: string};
  public isFBFeedLoaded = false;
  public isGoogleFeedLoaded = false;
  public isAccommodation = false;
  public fbLogo = config.fbLogo;
  public isGooglePlaceMatchedWithFBPlace = false;
  public isNotInitLoginStatusChanged = false;
  public NoFeed = false;
  public userSelectedToViewFeed = false;
  public isShowFacebookFeed = false;
  public isShowGoogleFeed = false;
  public isShowNearbyPlaces = false;
  public googleInfo: HubPlaceAdditionalData;
  public featuresToggle = new HubVisitorFeatureToggle();
  public placeSource = 'facebook';
  public detailDate = null;
  public detailTime = null;
  public isMultiDateEvent = false;
  public trancatedEventTimes = [];
  public trancatedEventTimesText = [];
  public facebookLogo = config.facebook.logo;
  public placePhotos = [];
  public placeImagesShownCount = 5;
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;
  @ViewChild('description') description: ElementRef;
  @ViewChild('tripTitle') public tripTitle: MatFieldComponent;
  @ViewChild('loginWithFBBtn') public loginWithFBBtn: FacebookLoginButtonComponent;
  @ViewChild('imgComp') public imgComp: ImageComponent;
  @ViewChild('imgViewer') public imgViewer: ImageViewerComponent;

  @Output() onAddToTrip: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveFromTrip: EventEmitter<any> = new EventEmitter();
  @Output() onAddNewTrip: EventEmitter<any> = new EventEmitter();
  @Output() onAddFirstTrip: EventEmitter<any> = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<TripDetailModalComponent>,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private actions: TripDetailModalActions,
    private formBuilder: FormBuilder,
    public imageService: ImageService,
    private location: Location,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private visitorTripStore: VisitorTripStore,
    private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
    private visitorApiService: VisitorApiService,
    private sanitizer: DomSanitizer,
    data: TripDetailModalData
  ) {
    super({activatedRoute});
    this.data = Object.assign({}, data);
  }

  public ngOnInit() {
    this.hubName = this.data.hubName;
    this.data.item.hubName = this.hubName;
    let {tripId} = this.allRouteParams;
    this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);

    if (tripId && tripId === 'tour-list') {
      this.data.isShowAddToTripBtn = false;
    }

    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.featuresToggle = command.toggle;
          this.data.isShowAddToTripBtn = this.featuresToggle.tripPlanner;
          this.placeSource = command.dataSource ? command.dataSource.place : this.data.item.socialName || 'facebook';
        }
        if (command.customSettings) {
          this.placeImagesShownCount = command.customSettings.placeImagesShownCount;
        }
      });

    if (this.isPlaceInfoNotLoaded) {
      this.getPlaceById(this.data.item.placeId).subscribe((data) => {
        if (data && data.length) {
          this.data.item = data[0];
          this.isAccommodation = this.data.type === 'place' && PlaceService.checkIsAccommodation(this.data.item);
          this.setGooglePlaceInfoAndFBPosts();
        }
      });
    } else if (this.isPlaceInfoLoaded) {
      this.isAccommodation = this.data.type === 'place' && PlaceService.checkIsAccommodation(this.data.item);
      this.setGooglePlaceInfoAndFBPosts();
    }

    if (this.isEvent) {
      if (this.isEventNotLoaded) {
        this.getEventById(this.data.item.eventId).subscribe((data) => {
          if (data && data.length) {
            this.data.item = data[0];
            this.processEvent();
          }
        });
      } else {
        this.processEvent();
      }
    }
  }

  public get isPlaceInfoNotLoaded() {
    return !this.data.item.name && this.data.item.placeId && this.data.type === 'place';
  }

  public get isEvent() {
    return this.data.type === 'event';
  }

  public get isEventNotLoaded() {
    return !this.data.item.name;
  }

  public get isPlaceInfoLoaded() {
    return this.data.type === 'place' && this.data.item.name;
  }

  public get normalTicketUri() {
    return this.data.item.ticketUri && (!this.data.item.ticketInfo || this.data.item.ticketInfo.length < 2);
  }

  public get processedTicketUri() {
    let noSchema = this.data.item.ticketUri.replace('https://', '');
    noSchema = noSchema.replace('http://', '');
    noSchema = noSchema.replace('www.', '');
    return noSchema.split('/')[0];
  }

  public get venueName() {
    return (
      (this.data.item.owner && this.data.item.owner.name) ||
      this.data.item.venue ||
      (this.data.item.venueInfo && this.data.item.venueInfo.name)
    );
  }

  public get videoTitle() {
    let title = '';
    if (this.data.item.youtubeLink) {
      title += 'Youtube Video';
    }
    if (this.data.item._360VideoKey) {
      title += title ? ' & 360° Video' : '360° Video';
    }
    return title;
  }

  // Youtube video link looks like:
  // https://www.youtube.com/watch?v=puKsjFRwIyw
  // https://www.youtube.com/watch?v=puKsjFRwIyw&t=27s
  public getYoutubeLink() {
    if (this.data.item.youtubeLink && this.data.item.youtubeLink.includes('watch?v=')) {
      const code = this.data.item.youtubeLink.split('watch?v=')[1].split('&')[0];
      const youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        config.youtubeUrl.replace('${code}', code)
      );
      return youtubeUrl;
    }
    return null;
  }

  get360VideoLink(): SafeResourceUrl {
    if (this.data.item._360VideoKey) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        config._360VideoUrl.replace('${id}', this.data.item._360VideoKey)
      );
    }
    return null;
  }

  public getLink(link) {
    if (link && !link.startsWith('http')) {
      return `http://${link}`;
    }
    return link;
  }

  public openTicketUrl(link: string) {
    window.open(link, '_blank');
  }

  public showMoreTimes() {
    if (this.trancatedEventTimes.length === 3) {
      this.trancatedEventTimes = this.data.item.eventTimes;
      if (this.data.item.eventTimesText) {
        this.trancatedEventTimesText = this.data.item.eventTimesText;
      }
    } else {
      this.trancatedEventTimes = this.data.item.eventTimes.slice(0, 3);

      if (this.data.item.eventTimesText && this.data.item.eventTimesText.length > 3) {
        this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, 3);
      }
    }
  }

  public getTel(tel) {
    return 'tel:' + tel;
  }

  public visitWebsite() {
    if (this.data.item.website || this.data.item.hostLink) {
      window.open(this.data.item.website || this.data.item.hostLink, '_blank');
    } else if (this.googleInfo && this.googleInfo.website) {
      window.open(this.googleInfo.website, '_blank');
    }
  }

  public buyTicket() {
    window.open(this.data.item['ticketUri'], '_blank');
  }

  public getDirection() {
    let address = this.data.item.address.address || this.data.item.address;
    let url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
    window.open(url, '_blank');
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public back() {
    this.isNotInitLoginStatusChanged = false;
    this.userSelectedToViewFeed = false;
  }

  public showEventLink() {
    const link = `${config.serverDomain}${this.data.item.hubName}/event-details/${this.data.item._id}`;
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        {provide: ShowInfoModalActions, useValue: null},
        {
          provide: InfoModalData,
          useValue: new InfoModalData('Event Link', null, [link], null, true),
        },
      ],
      panelClass: 'width-modal-100p-padding',
    });
  }

  public get isShowViewFBPostBtn() {
    return this.data.type === 'place' && this.data.item.hostLink && this.data.item.hostLink.indexOf('facebook') >= 0;
  }

  public showPlaceFeed(socialName) {
    if (socialName === 'facebook') {
      this.isShowFacebookFeed = true;
      this.isShowNearbyPlaces = false;
      this.isShowGoogleFeed = false;
    }
    if (socialName === 'google') {
      this.isShowFacebookFeed = false;
      this.isShowNearbyPlaces = false;
      this.isShowGoogleFeed = true;
    }
    if (socialName === 'nearby') {
      this.isShowFacebookFeed = false;
      this.isShowGoogleFeed = false;
      this.isShowNearbyPlaces = true;
    }
    this.userSelectedToViewFeed = true;
  }

  private async setGooglePlaceInfoAndFBPosts() {
    if (this.data.item.socialName === 'google') {
      this.googleInfo = await PlaceService.getGooglePlaceDetails(this.data.item, this.hubName, this.visitorApiService);
      if (this.googleInfo) {
        this.data.item.website = this.googleInfo.website;
        this.data.item.phone = this.googleInfo.formatted_phone_number || this.googleInfo.phone;
        this.data.item.hostGoogleLink = this.googleInfo.url || this.googleInfo.hostLink;
        this.data.item.priceRange = this.googleInfo.price_level;
        if (
          (this.googleInfo.reviews && this.googleInfo.reviews.length) ||
          (this.googleInfo.googleReviews && this.googleInfo.googleReviews.length)
        ) {
          this.isGoogleFeedLoaded = true;
        }
      }

      this.placePhotos =
        this.googleInfo.allowedGooglePhotos && this.googleInfo.allowedGooglePhotos.length
          ? this.googleInfo.allowedGooglePhotos
          : this.googleInfo.photos || [this.data.item.cover.source];
      console.log('this.placePhotos', this.placePhotos);
      this.placePhotos = this.placePhotos.map((x) => {
        let isReal = !!(this.googleInfo.allowedGooglePhotos && this.googleInfo.allowedGooglePhotos.length);
        return PlaceService.getGooglePlaceImageFullUrl(x.photo_reference || x, this.googleInfo.appKey, isReal, false);
      });
      console.log('this.placePhotos processed', this.placePhotos);
      this.placeImagesShownCount = Math.min(this.placeImagesShownCount, this.placePhotos.length);
      if (isNaN(this.placeImagesShownCount)) {
        this.placeImagesShownCount = 5;
      }
      if (this.data.item['category']) {
        this.data.item['category'] = PlaceService.allToReadableCategory(this.data.item['category']);
      }
      SeoService.createAndInjectGoogleStructureDataScriptForPlace(this.data.item);

      if (!this.isScriptSolution) {
        SeoService.addNameIdToUrlForPlaceForNonScriptSolution(this.location, this.data.item, this.dialogRef);
      } else {
        // for clients who use the script solution (embed ImGoing as a script into client's website)
        // change the URL by adding the ImGoing place name + Id to the params so that each place has a unique URL
        // when close the details modal, reset the URL to the original URL of the host site
        if (SeoService.getIfNeedToAddNameIdToUrl()) {
          SeoService.addNameIdToUrlForPlaceForScriptSolution(this.data.item, this.dialogRef);
        }
      }

      // PlaceService.getMatchedFacebookPlaceId(this.data.item, this.hubName, this.visitorApiService).then(data => {
      //     console.log(data);
      //     if (data.isMatched) {
      //         this.isGooglePlaceMatchedWithFBPlace = true;
      //         // this.data.item.description = data.description;
      //         this.data.item.hostFacebookLink = data.link;
      //         let id = ShareService.getFacebookPlaceId(data.link);
      //         this.getFacebookPlaceFeed(id);
      //     } else {
      //         this.placeFeeds = []; // no Facebook posts
      //     }
      // });
    } else {
      this.getFacebookPlaceFeed();
    }
  }

  public gotoPlace(item) {
    this.back();
    this.data = new TripDetailModalData(item, 'place', this.hubName, null, null, false, null);

    setTimeout(() => {
      this.imgComp && this.imgComp.updateImage(this.data.item.cover && this.data.item.cover.source);
      this.imgViewer && this.imgViewer.updateImage(this.data.item.cover && this.data.item.cover.source);
      this.setGooglePlaceInfoAndFBPosts();
    });
  }

  public viewFBPage() {
    if (this.data.item.socialName === 'facebook' && this.data.item.hostLink) {
      window.open(this.data.item.hostLink, '_blank');
    }
    if (this.data.item.socialName === 'google' && this.data.item.hostFacebookLink) {
      window.open(this.data.item.hostFacebookLink, '_blank');
    }
  }

  public viewFBPost() {
    if (!this.isFacebookLoggedIn) {
      this.isNotInitLoginStatusChanged = true;
      this.loginWithFBBtn.login();
    } else {
      if (!this.isFBFeedLoaded) {
        // this.getFBPost();
      } else {
        this.showPlaceFeed('facebook');
      }
    }
  }

  public getFacebookPlaceFeed(id?) {
    // the FB login status would be triggered once this modal is opened, and this function will be called, but we don't need to load the FB posts now
    if (!this.isNotInitLoginStatusChanged) {
      return;
    }
    // this.getFBPost(id);
  }

  private getFBPost(id?) {
    // // hostFacebookLink is for Google place which is matched with a FB place
    // id = id ? id : ShareService.getFacebookPlaceId(this.data.item.hostLink || this.data.item.hostFacebookLink);
    // this.NoFeed = false;
    // if (id && FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
    //   // this.userSelectedToViewFeed = true;
    //   let url = config.facebook.graphApi.placePosts
    //     .replace('${accessToken}', config.facebook.approvedApps[0])
    //     // .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
    //     .replace('${placeId}', id);
    //   FB.api(url, (response) => {
    //     this.placeFeedPaging = response.paging;

    //     if (!!response.error) {
    //       console.error(response.error);
    //       this.placeFeedPaging = null;
    //       this.NoFeed = true;
    //       this.isFBFeedLoaded = true;
    //       this.showPlaceFeed('facebook');
    //       return;
    //     }
    //     this.updatePlaceFeeds(response.data);
    //   });
    // }
  }

  public getNextFacebookPlaceFeed(event: ButtonTriggerEvent) {
    FB.api(this.placeFeedPaging.next, (response) => {
      event.complete();
      this.placeFeedPaging = response.paging;

      if (!!response.error) {
        console.error(response.error);
        return;
      }

      this.updatePlaceFeeds(this.placeFeeds.concat(response.data));
    });
  }

  private updatePlaceFeeds(placeFeeds) {
    // this.placeFeeds = placeFeeds.filter(x => x.message && x.from && x.actions && x.actions.length >= 2);
    this.placeFeeds = placeFeeds.filter((x) => x.message);
    this.placeFeeds.forEach((x) => {
      x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
      x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
    });
    setTimeout(() => {
      this.isFBFeedLoaded = true;
      if (this.placeFeeds && this.placeFeeds.length) {
        //this.onPlaceFeedsRetrieved.emit({item: this.item});
      } else {
        this.NoFeed = true;
      }
      this.showPlaceFeed('facebook');
    }, 100);
  }

  private processEvent() {
    this.setEventTimes();
    this.setDescription(this.data.item.description);
    this.setSeoItems();

    if (!this.isScriptSolution) {
      // // change location href, so that there can be a specific url for this place details
      SeoService.addNameIdToUrlForNonScriptSolution(this.location, this.data.item, this.dialogRef);
    } else {
      // for clients who use the whole html page solution (we give them a whole page that wraps ImGoing)
      // change the URL by adding the ImGoing event name + Id to the params so that each place has a unique URL
      // when close the details modal, reset the URL to the original URL of the host site
      if (SeoService.getIfNeedToAddNameIdToUrl()) {
        SeoService.addNameIdToUrlForScriptSolution(this.data.item, this.dialogRef);
      }
    }
  }

  private setDescription(description) {
    console.log('set description', description);
    if (description) {
      setTimeout(() => {
        console.log('this.description', this.description);
        if (this.description) {
          this.description.nativeElement.innerHTML = description;
        }
      }, 100);
    } else {
      setTimeout(() => {
        if (this.description) {
          this.description.nativeElement.innerHTML = '';
        }
      }, 100);
    }
  }

  private setSeoItems() {
    SeoService.createAndInjectGoogleStructureDataScriptForEvent(this.data.item);
  }

  private setEventTimes() {
    this.isMultiDateEvent = this.data.item.eventTimes && this.data.item.eventTimes.length > 1;

    EventTimeService.processEventTime(this.data.item);

    if (this.data.item.eventTimes && this.data.item.eventTimes.length > 3) {
      this.trancatedEventTimes = this.data.item.eventTimes.slice(0, 3);
    } else if (this.data.item.eventTimes && this.data.item.eventTimes.length <= 3) {
      this.trancatedEventTimes = this.data.item.eventTimes.slice(0, this.data.item.eventTimes.length);
    }
    if (this.data.item.eventTimesText && this.data.item.eventTimesText.length > 3) {
      this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, 3);
    } else if (this.data.item.eventTimesText && this.data.item.eventTimesText.length <= 3) {
      this.trancatedEventTimesText = this.data.item.eventTimesText.slice(0, this.data.item.eventTimes.length);
    }
  }

  private getPlaceById(id): Observable<HubPlace[]> {
    return this.visitorApiService.getPlaces(this.hubName, {
      page: 1,
      limit: 1,
      category: 'All',
      id,
    });
  }

  private getEventById(id): Observable<HubEvent[]> {
    return this.visitorApiService.getEvents(this.hubName, {
      page: 1,
      limit: 1,
      id,
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.detail.modal/trip.detail.modal.component.ts